import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/reservation-report';

const statistics = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/statistics`),
		data
	);
};

const weeklyPerformance = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/weekly-performance`
		),
		data
	);
};

const timeMatrix = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/time-matrix`),
		data
	);
};

const availabilityCalendar = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/availability-calendar`
		),
		data
	);
};

const workload = (systemSource, merchantId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservations/workload`
		),
		data
	);
};

const guestList = (systemSource, merchantId, branchId, data) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/reservations/guest-summary`
		),
		data
	);
};

export default {
	statistics,
	weeklyPerformance,
	timeMatrix,
	availabilityCalendar,
	workload,
	guestList,
};
